import type { IIconsButtonProps } from "@similarweb/ui-components";

import { StyledSaveDraftSignalButton } from "app/pages/sales-intelligence/sub-modules/signals/components/buttons/SaveDraftSignalButton/styles";

type Props = Required<Pick<IIconsButtonProps, "type" | "onClick">> &
    Partial<
        Pick<
            IIconsButtonProps,
            "isLoading" | "isDisabled" | "type" | "className" | "iconSize" | "iconName" | "children"
        >
    >;

const SaveDraftSignalButton = ({ iconName = "plus", ...restProps }: Props) => {
    return (
        <StyledSaveDraftSignalButton
            iconName={iconName}
            dataAutomation="save-signal-draft-button"
            {...restProps}
        />
    );
};

export default SaveDraftSignalButton;
